module.exports = __webpack_public_path__ + "media/images/fire-alert-c0da1701a1c3499b4dd2d9c21eef1d65.png";